var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasViewPermission }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasViewPermission,
              expression: "hasViewPermission"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c("div", { staticClass: "main-dialog" }, [
            _c(
              "div",
              { attrs: { id: "card-container" } },
              [
                _c("div", { staticClass: "input-form" }, [
                  _c("div", { staticClass: "card-design" }, [
                    _c("div", [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("system.user.query")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "all-forms" }, [
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("agent.agentNameText")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.listQuery.agentId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.listQuery, "agentId", $$v)
                                  },
                                  expression: "listQuery.agentId"
                                }
                              },
                              _vm._l(_vm.agentOption, function(item) {
                                return _c("el-option", {
                                  key: item.agentId,
                                  attrs: {
                                    label: item.agentName,
                                    value: item.agentId
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.moneyTypeToReport")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.listQuery.moneyTypeTo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.listQuery, "moneyTypeTo", $$v)
                                  },
                                  expression: "listQuery.moneyTypeTo"
                                }
                              },
                              _vm._l(_vm.moneyTypeFromOption, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.statisticsDate")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-date-picker", {
                              staticClass: "filter-item",
                              attrs: {
                                title: _vm.$t("SMS.statisticsDate"),
                                clearable: "",
                                type: "datetimerange",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                "range-separator": "-",
                                "start-placeholder": _vm.$t("common.fromTime"),
                                "end-placeholder": _vm.$t("common.toTime")
                              },
                              model: {
                                value: _vm.timeList,
                                callback: function($$v) {
                                  _vm.timeList = $$v
                                },
                                expression: "timeList"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "searchButton" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: {
                              plain: _vm.$store.getters.plainConf,
                              type: "info",
                              icon: "el-icon-search"
                            },
                            on: { click: _vm.handleFilter }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.search")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "actions" }, [
                  _c(
                    "div",
                    { staticClass: "otherActions" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "info",
                            icon: "el-icon-view"
                          },
                          on: { click: _vm.getStatistic }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("SMS.statistic")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasExportPermission,
                              expression: "hasExportPermission"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "info",
                            icon: "el-icon-download"
                          },
                          on: { click: _vm.handleExportReport }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("SMS.export")) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "addEditOrDelete" })
                ]),
                _vm._v(" "),
                _vm.viewSummary
                  ? _c("summary-popup", {
                      attrs: { "data-list": _vm.summaryList }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasViewPermission,
                        expression: "hasViewPermission"
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading"
                      }
                    ],
                    key: _vm.tableKey,
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.list,
                      stripe: _vm.$store.getters.stripeConf,
                      border: _vm.$store.getters.borderConf
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.agentId"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content:
                                      _vm.$t("agent.agentNameText") +
                                      " : " +
                                      scope.row.agentName +
                                      " ," +
                                      _vm.$t("agent.agentIdText") +
                                      " : " +
                                      scope.row.agentId
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.agentName))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.total"),
                        align: "center",
                        prop: "totalCount",
                        "min-width": _vm.customTableColumnWidth("sm")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.orderCreateFailCount"),
                        align: "center",
                        prop: "orderCreateFailCount",
                        "min-width": _vm.customTableColumnWidth("sm")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.orderCreateSuccessCount"),
                        align: "center",
                        prop: "orderCreateSuccessCount",
                        "min-width": _vm.customTableColumnWidth("md")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.channelSubmitFailCount"),
                        align: "center",
                        prop: "channelSubmitFailCount",
                        "min-width": _vm.customTableColumnWidth("md")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.channelSubmitSuccessCount"),
                        align: "center",
                        prop: "channelSubmitSuccessCount",
                        "min-width": _vm.customTableColumnWidth("md")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.channelNotifyFailCount"),
                        align: "center",
                        prop: "channelNotifyFailCount",
                        "min-width": _vm.customTableColumnWidth("md")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.channelNotifySuccessCount"),
                        align: "center",
                        prop: "channelNotifySuccessCount",
                        "min-width": _vm.customTableColumnWidth("md")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.depositedCount"),
                        align: "center",
                        prop: "depositedCount",
                        "min-width": _vm.customTableColumnWidth("md")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.refundCount"),
                        align: "center",
                        prop: "refundCount",
                        "min-width": _vm.customTableColumnWidth("md")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.amountOfConsumption"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", { staticClass: "ellipsis" }, [
                                _vm._v(
                                  _vm._s(
                                    scope.row.processConsumeAmount +
                                      " " +
                                      scope.row.moneyTypeFrom
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.channelCost"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", { staticClass: "ellipsis" }, [
                                _vm._v(
                                  _vm._s(
                                    scope.row.processChannelCostAmount +
                                      " " +
                                      scope.row.moneyTypeFrom
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.agencyProfit"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", { staticClass: "ellipsis" }, [
                                _vm._v(
                                  _vm._s(
                                    scope.row.processAgentIncomeAmount +
                                      " " +
                                      scope.row.moneyTypeFrom
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.profit"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", { staticClass: "ellipsis" }, [
                                _vm._v(
                                  _vm._s(
                                    scope.row.processIncomeAmount +
                                      " " +
                                      scope.row.moneyTypeFrom
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.moneyTypeToReport"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", { staticClass: "ellipsis" }, [
                                _vm._v(_vm._s(scope.row.moneyTypeTo))
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.date"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.dateFormat(
                                      scope.row.statisticalDate
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(
                                            scope.row.statisticalDate
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasViewPermission,
                      expression: "hasViewPermission"
                    }
                  ],
                  attrs: {
                    total: _vm.total,
                    page: _vm.listQuery.pageNum,
                    limit: _vm.listQuery.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.listQuery, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.listQuery, "pageSize", $event)
                    },
                    pagination: _vm.getList
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }